/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Heading } from '@sonarsource/echoes-react';
import { translate } from '~sq-server-commons/helpers/l10n';
import { Branch } from '~sq-server-commons/types/branch-like';
import { NewCodeDefinition } from '~sq-server-commons/types/new-code-definition';
import { Component } from '~sq-server-commons/types/types';
import BranchList from './BranchList';

interface Props {
  branchList: Branch[];
  component: Component;
  globalNewCodeDefinition: NewCodeDefinition;
  projectNewCodeDefinition: NewCodeDefinition;
}

export function BranchListSection({
  branchList,
  component,
  globalNewCodeDefinition,
  projectNewCodeDefinition,
}: Readonly<Props>) {
  return (
    <div className="sw-mt-6">
      <Heading as="h3" className="sw-mb-4">
        {translate('project_baseline.configure_branches')}
      </Heading>

      <BranchList
        branchList={branchList}
        component={component}
        globalNewCodeDefinition={globalNewCodeDefinition}
        inheritedSetting={projectNewCodeDefinition}
      />
    </div>
  );
}
